import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

const ApplyPay = () => {
    return <Redirect to="/apple-developer-merchantid-domain-association.txt" />;
};

export default ApplyPay;
